import { render } from "./StandingsView.vue?vue&type=template&id=af4efede&scoped=true"
import script from "./StandingsView.vue?vue&type=script&lang=js"
export * from "./StandingsView.vue?vue&type=script&lang=js"

import "./StandingsView.vue?vue&type=style&index=0&id=af4efede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4efede"]])

export default __exports__